import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { delay, map } from 'rxjs/operators';

import { EventType } from '../models/events';
import { EventsManagerService } from '../services/eventsmanager.service';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  private config: any;

  // Cache
  public CacheConfig: any = {};

  constructor(
    private http: HttpClient,
    private eventsManagerService: EventsManagerService
  ) { }

  load(url: string) {
    return new Promise<void>((resolve) => {
      this.http.get(url)
        .subscribe(config => {
          this.config = config;
          // const _currentTheme = this.config.AppConfig.CurrentThems;
          // const _theme = this.config.AppConfig.Themes.find((theme: any) => theme.Name === _currentTheme);
          // Tools.SetThemeColors(_theme || null);
          // this.loadRemoteConfig(resolve);
          resolve();
        });
    });
  }

  loadRemoteConfig(resolve: any) {
    const url = `${this.config.AppConfig.ONAMREST['HOST']}${this.config.AppConfig.ONAMREST['MEDICALSERVICES']}`;
    this.http.get(`${url}`).subscribe(
      (response: any) => {
        // Tools.DataTables['SERVICES'] = response.data;

        // Tools.DataTables['GENDERTYPE'] = [
        //   { value: 'male', label: 'male' },
        //   { value: 'female', label: 'female' }
        // ];

        // Tools.DataTables['MUSCLEIMBALANCES'] = [
        //   { id: 1, label: 'muscle_imbalance_1' },
        //   { id: 2, label: 'muscle_imbalance_2' },
        //   { id: 3, label: 'muscle_imbalance_3' }
        // ]

        // Tools.DataTables['LEFTRIGHTMIXLIST'] = [
        //   { id: 1, label: 'leftRightMix_1' },
        //   { id: 2, label: 'leftRightMix_2' },
        //   { id: 3, label: 'leftRightMix_3' }
        // ]
        if (resolve) { resolve(); }
        // this.eventsManagerService.broadcast(EventType.CONFIG_UPDATE, null);
      },
      (error: any) => {
        if (resolve) { resolve(); }
      }
    );
  }

  getConfiguration() {
    return this.config;
  }

  getAppConfig() {
    return this.config.AppConfig;
  }


  getSessionPrefix() {
    return this.config.sessionPrefix;
  }

  getConfig(name: string, suffix: string = '-config') {
    if (this.CacheConfig[name]) {
      let obs = new Observable((subscriber) => {
        subscriber.next(this.CacheConfig[name]);
        subscriber.complete();
      });
      return obs;
    } else{
      return this.http.get<any>(`./assets/config/${name}${suffix}.json`)
        .pipe(
          map((response: Response) => {
            this.CacheConfig[name] = response;
            return response;
          })
        );
    }
  }

  getJson(name: string) {
    const _timeout = this.config.AppConfig.DELAY || 0;
    return this.http.get<any>(`./assets/json/${name}.json`);
  }

  getPage(name: string) {
    return this.http.get<any>(`./assets/pages/${name}.html`, { responseType: 'text' as 'json' });
  }

  getFile(name: string, folder: string) {
    return this.http.get<any>(`./${folder}/${name}`, { responseType: 'blob' as 'json' });
  }
}
